import { IBookingIcon } from '../../../../../../BaseComponents/CalendarView/Utils/EDCalendarViewUtils';
import { IconType } from '../../../../../../BaseComponents/Icon/Utils/IconDefinitions';

interface IActivity {
  BEVAKNING?: boolean | null;
  KREMERING?: 'KREMERING' | 'JORDBEGRAVNING' | undefined | null;
  SKK_SPRIDNINGSTYP_EXTERN?: boolean | null;
  _typ?: string | null;
  _Associations?: {
    Dokument?: any[] | null;
    Dokument_All?: any[] | null;
    Avlidna?: {
      AKT_MED_URNA?: boolean | null;
    } | null;
  } | null;
}

interface IIconConfig {
  condition: (activity: IActivity) => boolean;
  icon: IconType;
  tooltip: string;
}

const hasDocuments = (activity: IActivity): boolean => {
  return (
    (Array.isArray(activity?._Associations?.Dokument) &&
      activity._Associations.Dokument.length > 0) ||
    (Array.isArray(activity?._Associations?.Dokument_All) &&
      activity._Associations.Dokument_All.length > 0)
  );
};

const isFuneralType = (typ?: string | null): boolean => {
  return typ === 'BEGRAVNING' || typ === 'GRAVSATTNING';
};

export function getActivityIcon(
  activity: IActivity,
  returnTooltips: boolean
): IBookingIcon[] {
  const iconConfigs: IIconConfig[] = [
    {
      condition: (activity): boolean => activity?.BEVAKNING === true,
      icon: 'visibility',
      tooltip: 'Bevakas',
    },
    {
      condition: (activity): boolean =>
        activity?.KREMERING === 'JORDBEGRAVNING' &&
        isFuneralType(activity?._typ),
      icon: 'coffin',
      tooltip: 'Jordbegravning',
    },
    {
      condition: (activity): boolean =>
        activity?.SKK_SPRIDNINGSTYP_EXTERN === true,
      icon: 'public',
      tooltip: 'Extern publicering',
    },
    {
      condition: (activity): boolean =>
        activity?.KREMERING === 'KREMERING' &&
        isFuneralType(activity?._typ) &&
        activity?._Associations?.Avlidna?.AKT_MED_URNA !== true,
      icon: 'cremation_plain',
      tooltip: 'Kremering',
    },
    {
      condition: (activity): boolean =>
        activity?.KREMERING === 'KREMERING' &&
        isFuneralType(activity?._typ) &&
        activity?._Associations?.Avlidna?.AKT_MED_URNA === true,
      icon: 'cremation_act',
      tooltip: 'Akt med urna',
    },
    {
      condition: hasDocuments,
      icon: 'attach_file',
      tooltip: 'Bifogat dokument',
    },
  ];

  // Filter to get only the configs that match the conditions
  const matchingConfigs = iconConfigs.filter(config =>
    config.condition(activity)
  );

  // If no matching configs, return empty array
  if (matchingConfigs.length === 0) {
    return [];
  }
  if (returnTooltips) {
    // Return icons and tooltips
    return matchingConfigs.map((config: IIconConfig) => ({
      icon: config.icon,
      tooltip: config.tooltip,
    }));
  } else {
    // Return icons
    return matchingConfigs.map((config: IIconConfig) => ({
      icon: config.icon,
    }));
  }
}
